import styled from 'styled-components';

const Divider = styled.div`
  height: ${(props) => props.height || '0.47rem'};
  width: 100%;
  background-color: ${(props) => props.color || '#f1f1f1'};
`;

export default Divider;
